import de from "../i18n/de/freigabe.json";
import en from "../i18n/en/freigabe.json";
import { transportTopicError } from "./transportTopicErrors";
import { transportBatchError } from "./transportBatchErrors";
import { transportPackageError } from "./transportPackageErrors";

export function transportPreflightError(error, language = "de") {
  const catalog = String(language).toLowerCase().startsWith("en") ? en : de;
  const code = typeof error === "string" ? error : error?.code || error?.body?.code;
  if (code === "TRANSPORT_PREPARATION_BLOCKED" && typeof error?.body?.error === "string" && error.body.error.trim())
    return `${error.body.error.trim()} ${catalog.preflight.preparationRemedy}`;
  if (code === "TOPIC_PACKAGE_ENDPOINT_REQUIRED") return transportTopicError(error, language);
  // Pakettransport (Welle 6): eigener Katalog, bei Einzelheiten mit dem Servertext
  // (auch PACKAGE_TRANSPORT_TARGET_UNVERIFIED und PACKAGE_TRANSPORT_TARGET_UNREADABLE, DEV182).
  const packageText = transportPackageError(error, language);
  if (packageText) return packageText;
  const known = catalog.preflight.errors[code] || catalog.topics.errors[code] || catalog.packageTopic.errors[code];
  if (known) return known;
  const fallback = catalog.preflight.fallback + (/^[A-Z][A-Z0-9_]{2,80}$/.test(code || "") ? ` (${code})` : "");
  if (String(code || "").startsWith("TOPIC_")) return fallback;
  return transportBatchError(error, language, fallback);
}

export function preflightApprovalError(error, t) {
  const code = error?.code || error?.body?.code;
  const reason = error?.body?.error || error?.error;
  if (code === "TRANSPORT_PREPARATION_BLOCKED" && typeof reason === "string" && reason.trim())
    return `${reason.trim()} ${t("preflight.preparationRemedy")}`;
  if (typeof code !== "string" || !Object.prototype.hasOwnProperty.call(de.preflight.errors, code)) return "";
  return t(`preflight.errors.${code}`, { defaultValue: "" });
}
